/** Pure logic — no DOM, no Preact imports. */

export const REFERENCE_SPEED_KMH = 100;

export interface TireSpec {
  width: number;
  aspect: number;
  inches: number;
}

export interface RolloutResult {
  refCircumferenceMm: number;
  newCircumferenceMm: number;
  deviationPercent: number;
  displayedSpeedKmh: number;
  speedDeltaKmh: number;
  withinTolerance: boolean;
}

/** Geometrischer Abrollumfang in mm: π · (2 · width · aspect/100 + inches · 25.4) */
export const tireCircumferenceMm = (spec: TireSpec): number => {
  const sidewallMm = (spec.width * spec.aspect) / 100;
  const diameterMm = 2 * sidewallMm + spec.inches * 25.4;
  return diameterMm * Math.PI;
};

export const calculateRollout = (
  ref: TireSpec,
  next: TireSpec,
  referenceSpeedKmh: number,
  tolerancePercentMin: number,
  tolerancePercentMax: number,
): RolloutResult => {
  const refCircumferenceMm = tireCircumferenceMm(ref);
  const newCircumferenceMm = tireCircumferenceMm(next);
  const deviationPercent =
    ((newCircumferenceMm - refCircumferenceMm) / refCircumferenceMm) * 100;
  const displayedSpeedKmh = referenceSpeedKmh * (refCircumferenceMm / newCircumferenceMm);
  const speedDeltaKmh = displayedSpeedKmh - referenceSpeedKmh;
  const withinTolerance =
    deviationPercent >= tolerancePercentMin && deviationPercent <= tolerancePercentMax;
  return {
    refCircumferenceMm,
    newCircumferenceMm,
    deviationPercent,
    displayedSpeedKmh,
    speedDeltaKmh,
    withinTolerance,
  };
};

/** Lineares Mapping eines Werts auf einen Halbkreis-Winkel: -90° (links) bis +90° (rechts). */
export const mapSpeedToAngle = (speed: number, min: number, max: number): number => {
  const clamped = Math.max(min, Math.min(max, speed));
  const ratio = (clamped - min) / (max - min);
  return ratio * 180 - 90;
};
